import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const GenericAutoLoanModuleView = ({ ...props }) => {
  return (
    <>
      {props?.genericAutoLoanOffers?.length > 0 && (
        <>
          <Row fullWidth>
            <Disclaimer showPartnerText className="margB8" />
          </Row>
          <SectionContainer>
            <Row>
              <Label type="H3" typeHeader={'h3'}>
                Auto loan offers you may be interested in
              </Label>
              <div className="padB16 desktopOnlyHide"></div>
              <div className="padB32 mobileOnlyHide"></div>
              <GenericAutoLoanOffersContainer {...props} />
            </Row>
          </SectionContainer>
        </>
      )}
    </>
  );
};

const GenericAutoLoanOffersContainer = ({ ...props }) => {
  if (props.autoLoanCache?.genericAutoLoanOffers?.loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <FlexContainer className="flex-column">
        <StaticOfferContainer
          hideDetails
          offerMetadataList={props.genericAutoLoanOffers}
          eventHandler={props.eventHandler}
          pagePosition={props.moduleName}
          modulePosition={props.modulePosition}
          loanType={'Purchase'}
          optimizelyExperimentObj={{}}
          preventInnerLoading={false}
        ></StaticOfferContainer>
      </FlexContainer>
    );
  }
};

export default GenericAutoLoanModuleView;
